import { API_ROUTES } from '@/constants/api-routes';
import { API_URL_V3 } from '@/constants/constants';
import { QUERY_KEYS } from '@/constants/query-keys';
import { generateAuthHeaders } from '@/utils/generate-auth-headers';
import axios from 'axios';
import { useMutation } from 'react-query';

export interface DisconnectStripeResponse {
  message: string;
}

const useDisconnectStripe = ({ options }) => {
  return useMutation<DisconnectStripeResponse>(
    async () => {
      const { data } = await axios<DisconnectStripeResponse>({
        baseURL: API_URL_V3,
        url: API_ROUTES.DISCONNECT_STRIPE,
        method: 'POST',
        headers: generateAuthHeaders(),
      });

      return data;
    },
    {
      mutationKey: QUERY_KEYS.DISCONNECT_STRIPE,
      ...options,
    },
  );
};

export default useDisconnectStripe;
